module.exports = __webpack_public_path__ + "img/1f427.91367ad.svg";